import { RootState } from "redux-features/store";

export const selectCurrentStep = (state: RootState) =>
  state.userActivity.currentStep;
